import { useState } from 'react';
import translator from '@Components/Utilities/Translator';
import { bidCallerCollectionTypes } from '@Components/Utilities/SandhillsConstants';

const CollectionLotBanner = ({ collectionInfo, listingId }) => {
    const [showModal, setShowModal] = useState(false);

    if (!collectionInfo?.Listings || !collectionInfo.CollectionTypeDisplay) {
        return null;
    }

    const isQuantityType = collectionInfo.CollectionType === bidCallerCollectionTypes.SplitTimesTheMoney ||
                           collectionInfo.CollectionType === bidCallerCollectionTypes.TimesTheMoney;

    const currentListingQuantity = isQuantityType
        ? (collectionInfo.Listings.find(l => l.ListingID == listingId) || collectionInfo.Listings[0])?.Quantity
        : null;

    const openModal = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setShowModal(true);
    };

    const closeModal = () => setShowModal(false);

    return (
        <>
            <div
                className='collection-lot-banner no-print'
                role='button'
                tabIndex='0'
                aria-label={collectionInfo.CollectionTypeDisplay}
                onClick={openModal}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { openModal(e); } }}
            >
                <span>{collectionInfo.CollectionTypeDisplay}</span>
                <i aria-hidden='true' className='fas fa-info-circle' title={collectionInfo.ToolTip} />
            </div>
            {showModal &&
                <div className='collection-lot-modal-overlay' onClick={closeModal}>
                    <div className='collection-lot-modal' role='dialog' aria-modal='true' aria-label={collectionInfo.CollectionTypeDisplay} onClick={(e) => e.stopPropagation()}>
                        <div className='collection-lot-modal__header'>
                            <h2 className='collection-lot-modal__title'>{collectionInfo.CollectionTypeDisplay}</h2>
                            <button className='collection-lot-modal__close' onClick={closeModal} aria-label={translator.translate('sandhills.close')}>
                                <i aria-hidden='true' className='fas fa-times' />
                            </button>
                        </div>
                        <ul className='collection-lot-modal__list'>
                            {isQuantityType
                                ? <li className='collection-lot-modal__list-item'>{`Quantity: ${currentListingQuantity}`}</li>
                                : collectionInfo.Listings.length > 1
                                    ? collectionInfo.Listings.map((listing, index) => (
                                        <li key={index} className='collection-lot-modal__list-item'>
                                            <a className='collection-lot-modal__link' href={listing.ListingURL} target='_blank' aria-label={`Lot ${listing.LotNumber} (${translator.translate('sandhills.openinanewtab')})`}>
                                                {`Lot ${listing.LotNumber}`}
                                                <span className='visually-hidden'>{translator.translate('sandhills.openinanewtab')}</span>
                                            </a>
                                        </li>
                                    ))
                                    : <li className='collection-lot-modal__list-item'>
                                        {translator.translate('sandhills.quantity')}:&nbsp;{collectionInfo.Listings[0].Quantity}&nbsp;{collectionInfo.Listings[0].QuantityLabel}
                                    </li>
                            }
                        </ul>
                        {collectionInfo.Description && <p className='collection-lot-modal__description'>{collectionInfo.Description}</p>}
                    </div>
                </div>
            }
        </>
    );
};

export default CollectionLotBanner;
